import React, { useState, useContext, useEffect, forwardRef, useImperativeHandle } from 'react';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { TextField, Checkbox, Button, Typography, Radio, FormControlLabel, FormControl, RadioGroup, Snackbar, StepConnector, StepLabel, Link, Dialog, DialogContent, DialogActions } from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import MuiAlert from '@material-ui/lab/Alert';
import 'date-fns';
import clsx from 'clsx';
import Check from '@material-ui/icons/Check';
import PropTypes from 'prop-types';
import { ConvertToCurrentTimeZone } from '../header/timeFormatter';
import { HttpService } from '../../apiAuthorization/httpService';
import { GlobalTheme } from '../../layouts/theme';
import { Context } from '../contexts/siteContext.js';
import { Theme } from '../contexts/themeContext.js';
import { TransactionTime } from '../common/transactionTime';
import InactiveTimeout from '../common/inactiveTimeout';
import Grid from '@material-ui/core/Grid';
import AlertDialog from '../alertDialog/alertDialog.js';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/Cancel'
import ContentDialog from '../common/contentDialog.js';
import ConfirmDialog from '../common/confirmDialog';
import InputAdornment from '@material-ui/core/InputAdornment';
import RdoDirectorActionAdd from './directorActionAdd';
import TeamCoachList from '../teamCoach/teamCoachAdd';
import { OfflineService } from "../../offline/storageService/offlineService";
import { SaveRDOSectionOfflineData, GetRDOSections } from "../../offline/dataService/rdoAccountVisitationOfflineData";

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const useQontoStepIconStyles = makeStyles({
    root: {
        color: '#eaeaf0',
        display: 'flex',
        height: 22,
        alignItems: 'center'
    },
    active: {
        color: '#E45B1A'
    },
    circle: {
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: 'currentColor'
    },
    completed: {
        color: '#E45B1A',
        zIndex: 1,
        fontSize: 18
    },
});

function QontoStepIcon(props) {
    const classes = useQontoStepIconStyles();
    const { active, completed } = props;

    return (
        <div
            className={clsx(classes.root, {
                [classes.active]: active,
            })}
        >
            {completed ? <Check className={classes.completed} /> : <div className={classes.circle} />}
        </div>
    );
}

const QontoConnector = withStyles({
    alternativeLabel: {
        top: 10,
        left: 'calc(-50% + 16px)',
        right: 'calc(50% + 16px)'
    },
    active: {
        '& $line': {
            borderColor: '#E45B1A'
        }
    },
    completed: {
        '& $line': {
            borderColor: '#E45B1A'
        }
    },
    line: {
        borderColor: '#eaeaf0',
        borderTopWidth: 3,
        borderRadius: 1
    }
})(StepConnector);

QontoStepIcon.propTypes = {
    /**
     * Whether this step is active.
     */
    active: PropTypes.bool,
    /**
     * Mark the step as completed. Is passed to child components.
     */
    completed: PropTypes.bool,
};

const useStyles = makeStyles(theme => ({
    root: {
        '& > *': {
            margin: '7px 0px',
            width: '100%'
        }
    },
    button: {
        width: '15%',
        float: 'right'
    },
    flButton: {
        float: 'right'
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        maxWidth: 300
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    },
    notAllowed: {
        cursor: 'not-allowed'
    },
    textBlod: {
        fontWeight: '600'
    },
    green: {
        backgroundColor: '#00b5ad',
        color: 'white',
        '&:hover': {
            backgroundColor: '#05a19a',
        }
    },
    mt10: {
        marginTop: '10px'
    },
    mb10: {
        maginBottom: '10px'
    }
}));

const RdoAccountVisitationAdd = forwardRef((props, ref) => {
    const classes = useStyles();
    const offlineService = new OfflineService();
    const { rdoAccountVisitationSelected, action } = props;
    const { defaultSite } = useContext(Context);
    const { theme } = useContext(Theme);
    const [showInactiveMessage, setShowInactiveMessage] = useState(false);
    const [reflect] = useState(false);
    const [backDrop, setBackDrop] = useState(true);
    const [openError, setOpenError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [openSuccess, setOpenSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [activeStep, setActiveStep] = useState(0);
    const [teamCoachId, setTeamCoachId] = useState(0);
    const [canSave, setCanSave] = useState(true);
    const teamCoachIdRef = React.useRef();

    const [openDialog, setOpenDialog] = useState(false);
    const [isShowDirectorRdo, setIsShowDirectorRdo] = useState(false);
    const [rdoSectionOptionsBase, setRdoSectionOptionsBase] = useState([]);
    const [housekeepingCartTemplate, setHousekeepingCartTemplate] = useState([]);
    const [verifyFollowingProperlyTemplate, setVerifyFollowingProperlyTemplate] = useState([]);
    const [contractualAccountabilitieTemplate, setContractualAccountabilitieTemplate] = useState([]);
    const [followUpList, setFollowUpList] = useState([]);
    const [rdoParameters, setRdoParameters] = useState([]);
    const [isRdoDirectorActionAdd, setIsRdoDirectorActionAdd] = useState(false);
    const [isShowTeamCoach, setIsShowTeamCoach] = useState(false);
    const [isShowComfirm, setIsShowComfirm] = useState(false);
    const [comfirmMessage, setComfirmMessage] = useState('');
    const [currentTeamCoachKey, setCurrentTeamCoachKey] = useState('');
    const [unSavedIndexStep, setUnSavedIndexStep] = useState(-1);

    const currentTheme = theme ? (GlobalTheme[theme]) : (GlobalTheme[localStorage.getItem("theme")]);

    const [stepTitles] = useState(["Client Engagement", "Purposeful Rounding", "Operational Integrity", "Financial Stewardship", "Observation & Notes"]);

    const closeSuccessSnackbar = () => {
        setOpenSuccess(false);
    };

    const [rdoClass, setRdoClass] = useState({
        readOnly: false,
        returnedFromCoach: false,
        baseModel: {
            Id: 0,
            SiteId: defaultSite.id,
            Account: '',
            AccountVisitDate: null,
            Director: null,
            RDO: null,
            RDORating: 0,
            SectionsCompleted: 0,
            DirectorCopy: null,
            RDOCopy: null,
            Item1Notes: '', Item2Notes: '', Item3Notes: '', Item4Notes: '', Item5Notes: '', Item6Notes: '',
            IsDraftSaved: false,
            DraftSave: false,
            RecipientsEmailId: "",
            RDOAccountVisitSectionList: [],

        },
        model: {},
        initModel: function () {
            this.model = JSON.parse(JSON.stringify(this.baseModel));
            this.readOnly = false;
            this.btnCanSubmit = true;
        },
        fill: function (item) {
            this.initModel();
            this.model.Id = item.Id;
            this.model.SiteId = item.SiteId;
            this.model.Director = item.Director;
            this.model.RDO = item.RDO;
            this.model.Account = item.SiteName === undefined ? item.Account : item.SiteName;
            this.model.AccountVisitDate = item.AccountVisitDateTimeString === undefined ? item.AccountVisitDate : item.AccountVisitDateTimeString;
            this.model.RDORating = item.RDORating;
            this.model.SectionsCompleted = item.SectionsCompleted;
            this.model.Item1Notes = item.Item1Notes;
            this.model.Item2Notes = item.Item2Notes;
            this.model.Item3Notes = item.Item3Notes;
            this.model.Item4Notes = item.Item4Notes;
            this.model.Item5Notes = item.Item5Notes;
            this.model.Item6Notes = item.Item6Notes;
            this.model.IsDraftSaved = item.IsDraftSaved;
            this.model.DraftSave = item.DraftSave;
            this.model.RecipientsEmailId = item.RecipientsEmailId;
            this.readOnly = item.IsDraftSaved;
            this.forceUpdate();
        },
        init: function (action) {
            step1.init();
            step2.init();
            step3.init();
            step4.init();
            step5.init();

            if (action === 'Add') {
                this.initModel();
                this.model.AccountVisitDate = ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY", null, defaultSite);
                getRDOAndDirector();
            }

            //get parameter
            getRDOParameters(this.model.AccountVisitDate);

        },
        btnDisabled: function () {

            if (this.model.Director && this.model.RDO && rdoSectionOptionsBase) {
                return false;
            }

            return true;
        },
        clearCurrentStepModel: function () {
            this.currentStepModel = JSON.parse(JSON.stringify({}));
        },
        currentStepModel: {},
        forceUpdate: function () {
            setRdoClass({ ...rdoClass, model: this.model });
        }
    });

    const [step1, setStep1] = useState({
        onTeamCoach: function () {
            if (sessionStorage.getItem("isOffline") === "1") {
                setErrorMessage("Team Coach is unavailable in Offline Mode. Please connect to the internet.");
                setOpenError(true);
                return;
            }
            else if (!teamCoachIdRef.current || teamCoachIdRef.current === 0) {
                setErrorMessage("The Site " + defaultSite.name + " has not been setup to access Coach.");
                setOpenError(true);
                return;
            }
            getApiHirnodesFlattenedFullHirnodeBySite(function () { showTeamCoach("CompleteInterviewCoach"); });
        },
        init: function () {
            this.model = JSON.parse(JSON.stringify(this.baseModel));
            this.setOriginalModel();
        },
        baseModel: {
            StepName: "step1",
            Id: 0,
            SectionId: 1,
            RDOAccountVisitId: 0,
            CompleteInterviewFollowUp: false,
            CompleteInterviewCoachCompletedCount: null,
            CompleteInterviewCoachFormIdArr: [],
            CompleteInterviewCoachFormIds: null,
            CoachKey: "CompleteInterviewCoach", //default value
            SectionComments: "",
            SectionComplete: false,
            Hirnode: null,
            Interviewee: null,
            SurveyData: [],
        },
        model: {},
        originalModel: {},
        setOriginalModel: function () {
            this.originalModel = JSON.parse(JSON.stringify(this.model));
            setStep1({ ...step1, originalModel: this.originalModel });
        },
        fill: function (item) {
            this.model.Id = item.Id;
            this.model.RDOAccountVisitId = item.RDOAccountVisitId;
            this.model.CompleteInterviewFollowUp = item.CompleteInterviewFollowUp;
            if (item.CompleteInterviewFollowUp) setFollowUpList(...followUpList, '• Client Engagement');
            this.model.CompleteInterviewCoachCompletedCount = item.CompleteInterviewCoachCompletedCount;
            this.model.CompleteInterviewCoachFormIds = item.CompleteInterviewCoachFormIds;
            //set arr
            if (item.CompleteInterviewCoachFormIds) {
                this.model.CompleteInterviewCoachFormIdArr = item.CompleteInterviewCoachFormIds.split(',');
            }
            else {
                this.model.CompleteInterviewCoachFormIdArr = [];
            }


            this.model.SectionComments = item.SectionComments;
            this.model.SectionComplete = item.SectionComplete;
            this.forceUpdate();
            this.setOriginalModel();
        },
        save: function () {
            saveRdoAccountVisitation();
        },
        checkModelChanged: function () {
            var changed = false;
            var model = this.model;
            //if saved
            if (model.Id !== this.originalModel.Id && model.Id > 0) {
                return false;
            }

            Object.entries(this.originalModel).forEach((entity) => {
                var key = entity[0];
                var value = entity[1];

                if (key !== "CompleteInterviewCoachFormIdArr" && key !== "SurveyData" && key !== "Id" && model[key] !== value) {
                    console.log(key, model[key], value);
                    changed = true;
                }
            });

            return changed;
        },
        setModel: function (name, val) {
            this.model[name] = val;
            this.forceUpdate();
            props.inputValueChanged();
        },
        forceUpdate: function () {
            setStep1({ ...step1, model: this.model });
        }
    });

    const [step2, setStep2] = useState({
        onTeamCoach: function (coachKey) {
            if (sessionStorage.getItem("isOffline") === "1") {
                setErrorMessage("Team Coach is unavailable in Offline Mode. Please connect to the internet.");
                setOpenError(true);
                return;
            }
            else if (!teamCoachIdRef.current || teamCoachIdRef.current === 0) {
                setErrorMessage("The Site " + defaultSite.name + " has not been setup to access Coach.");
                setOpenError(true);
                return;
            }

            showTeamCoach(coachKey);

        },
        init: function () {
            this.model = JSON.parse(JSON.stringify(this.baseModel));
            this.setOriginalModel();
        },
        baseModel: {
            StepName: "step2",
            Id: 0,
            RDOAccountVisitId: 0,
            CoachKey: null,

            SectionId: 2,

            QAInspectionHPUFollowUp: false,
            QAInspectionHPUCoachCompletedCount: null,
            QAInspectionHPUCoachFormIdArr: [],
            QAInspectionHPUCoachFormIds: null,

            QAInspectionHCAHPSFollowUp: false,
            QAInspectionHCAHPSCoachCompletedCount: null,
            QAInspectionHCAHPSCoachFormIdArr: [],
            QAInspectionHCAHPSCoachFormIds: null,

            HousekeepingCartFollowUp: false,
            HousekeepingCartIds: null,
            HousekeepingCartJson: null,

            HygienaATPReportFollowUp: false,
            MonthlyTests: null,  //decimal
            TestsPassingCompliance: null, //decimal

            OverallAccountAssessmentFollowUp: false,
            CustomerRounds: null, //decimal ,from query
            LaborOpCapacity: null, //decimal ,from query

            RTC60Compliance: null, //decimal ,from query
            PEObservations: null, //decimal ,from query
            HCAHPSResults: null, //decimal ,from query

            CleaningQAs: {},
            CleaningQAsYTDScore: "",
            CleaningQAsSurveyTitle: "",

            RDOAccountRating: 0, //int

            RDORatingComments: null,

            SectionComments: null,
            SectionComplete: false,
            SurveyData2: [],
            HCAHPSsurveyData: [],
        },
        model: {},
        originalModel: {},
        setOriginalModel: function () {
            this.originalModel = JSON.parse(JSON.stringify(this.model));
            setStep2({ ...step2, originalModel: this.originalModel });
        },
        fill: function (item) {
            this.model.Id = item.Id;
            this.model.RDOAccountVisitId = item.RDOAccountVisitId;
            this.model.QAInspectionHPUFollowUp = item.QAInspectionHPUFollowUp;
            this.model.QAInspectionHPUCoachCompletedCount = item.QAInspectionHPUCoachCompletedCount;
            this.model.QAInspectionHPUCoachFormIds = item.QAInspectionHPUCoachFormIds;
            //set arr
            if (item.QAInspectionHPUCoachFormIds) {
                this.model.QAInspectionHPUCoachFormIdArr = item.QAInspectionHPUCoachFormIds.split(',');
            }
            else {
                this.model.QAInspectionHPUCoachFormIdArr = [];
            }


            if (item.QAInspectionHPUFollowUp) setFollowUpList(...followUpList, '• High Priority Unit QAs');

            this.model.QAInspectionHCAHPSFollowUp = item.QAInspectionHCAHPSFollowUp;
            if (item.QAInspectionHCAHPSFollowUp) setFollowUpList(...followUpList, '• HPC/HCAHPS QAs');

            this.model.QAInspectionHCAHPSCoachCompletedCount = item.QAInspectionHCAHPSCoachCompletedCount;
            this.model.QAInspectionHCAHPSCoachFormIds = item.QAInspectionHCAHPSCoachFormIds;
            //set arr
            if (item.QAInspectionHCAHPSCoachFormIds) {
                this.model.QAInspectionHCAHPSCoachFormIdArr = item.QAInspectionHCAHPSCoachFormIds.split(',');
            }
            else {
                this.model.QAInspectionHCAHPSCoachFormIdArr = [];
            }



            this.model.HousekeepingCartFollowUp = item.HousekeepingCartFollowUp;
            if (item.HousekeepingCartFollowUp) setFollowUpList(...followUpList, '• Janitor Closet/Housekeeping Cart Compliance');
            this.model.HousekeepingCartIds = item.HousekeepingCartIds;
            this.model.HousekeepingCartJson = item.HousekeepingCartJson;

            this.model.HygienaATPReportFollowUp = item.HygienaATPReportFollowUp;
            if (item.HygienaATPReportFollowUp) setFollowUpList(...followUpList, '• Hygiena ATP Report Results');
            this.model.MonthlyTests = item.MonthlyTests;
            this.model.TestsPassingCompliance = item.TestsPassingCompliance;

            this.model.OverallAccountAssessmentFollowUp = item.OverallAccountAssessmentFollowUp;
            if (item.OverallAccountAssessmentFollowUp) setFollowUpList(...followUpList, '• Overall Account Assessment');
            this.model.CustomerRounds = item.CustomerRounds;
            this.model.LaborOpCapacity = item.LaborOpCapacity;

            this.model.RTC60Compliance = item.RTC60Compliance;
            this.model.PEObservations = item.PEObservations;
            this.model.HCAHPSResults = item.HCAHPSResults;

            this.model.RDOAccountRating = item.RDOAccountRating;

            this.model.RDORatingComments = item.RDORatingComments;

            this.model.SectionComments = item.SectionComments;
            this.model.SectionComplete = item.SectionComplete;

            this.model.CleaningQAsSurveyTitle = item.CleaningQAsSurveyTitle;
            this.model.CleaningQAsYTDScore = item.CleaningQAsYTDScore;


            if (this.model.CleaningQAsSurveyTitle) {
                var keys = this.model.CleaningQAsSurveyTitle.split(',');
                var value = this.model.CleaningQAsYTDScore.split(',');
                keys.forEach(function (key, i) {
                    rdoClass.step2.model.CleaningQAs[key] = value[i];
                });

            }

            if (item.HousekeepingCartJson) {
                setHousekeepingCartTemplate(JSON.parse(item.HousekeepingCartJson));
            }

            this.forceUpdate();
            this.setOriginalModel();
        },
        onRatingChange: function (rating) {

            if (rdoClass.readOnly)
                return;

            this.model.RDOAccountRating = rating;
        },
        save: function () {
            saveRdoAccountVisitation();
        },
        checkModelChanged: function (_housekeepingCartTemplate) {
            var template = _housekeepingCartTemplate;
            setCheckValue(template, this.model, "HousekeepingCartIds");
            this.model.HousekeepingCartJson = JSON.stringify(template);

            var changed = false;
            var model = this.model;
            var originalModel = this.originalModel;

            //if saved
            if (model.Id !== originalModel.Id && model.Id > 0) {
                return false;
            }

            var deleteKeyArr =
                [
                    "QAInspectionHPUCoachFormIdArr",
                    "QAInspectionHCAHPSCoachFormIdArr",
                    "CoachKey",
                    "CleaningQAs",
                    "CleaningQAsYTDScore",
                    "CleaningQAsSurveyTitle",
                    "HousekeepingCartJson",
                    //"Id",
                    "CustomerRounds",
                    "LaborOpCapacity",
                    "RTC60Compliance",
                    "PEObservations",
                    "HCAHPSResults",
                    "SurveyData2",
                    "HCAHPSsurveyData"
                ];

            deleteKeyArr.forEach(function (item, i) {
                delete originalModel[item];
            });

            Object.entries(originalModel).forEach((entity) => {
                var key = entity[0];
                var value = entity[1];

                if (model[key] !== value) {
                    changed = true;
                }
            });

            return changed;
        },
        setModel: function (name, val) {
            this.model[name] = val;
            this.forceUpdate();
            props.inputValueChanged();
        },
        forceUpdate: function () {
            setStep2({ ...step2, model: this.model });
        }
    });

    const [step3, setStep3] = useState({
        init: function () {
            this.model = JSON.parse(JSON.stringify(this.baseModel));
            this.setOriginalModel();
        },
        baseModel: {
            StepName: "step3",
            Id: 0,
            RDOAccountVisitId: 0,
            SectionId: 3,

            VerifyFollowingProperlyFollowUp: false,
            VerifyFollowingProperlyIds: null,
            VerifyFollowingProperlyJson: null,

            SectionComments: null,
            SectionComplete: false
        },
        model: {},
        originalModel: {},
        setOriginalModel: function () {
            this.originalModel = JSON.parse(JSON.stringify(this.model));
            setStep3({ ...step3, originalModel: this.originalModel });
        },
        fill: function (item) {
            this.model.Id = item.Id;
            this.model.RDOAccountVisitId = item.RDOAccountVisitId;
            this.model.VerifyFollowingProperlyFollowUp = item.VerifyFollowingProperlyFollowUp;
            if (item.VerifyFollowingProperlyFollowUp) setFollowUpList(...followUpList, '• Operational Integrity');
            this.model.VerifyFollowingProperlyIds = item.VerifyFollowingProperlyIds;
            this.model.VerifyFollowingProperlyJson = item.VerifyFollowingProperlyJson;

            this.model.SectionComments = item.SectionComments;
            this.model.SectionComplete = item.SectionComplete;

            if (item.VerifyFollowingProperlyJson) {
                setVerifyFollowingProperlyTemplate(JSON.parse(item.VerifyFollowingProperlyJson));
            }

            this.forceUpdate();
            this.setOriginalModel();
        },
        save: function () {

            var template = verifyFollowingProperlyTemplate;

            this.model.VerifyFollowingProperlyJson = JSON.stringify(template);

            saveRdoAccountVisitation();
        },
        checkModelChanged: function (_verifyFollowingProperlyTemplate) {

            var template = _verifyFollowingProperlyTemplate;

            setCheckValue(template, this.model, "VerifyFollowingProperlyIds");
            this.model.VerifyFollowingProperlyJson = JSON.stringify(template);

            var changed = false;
            var model = this.model;

            //if saved
            if (model.Id !== this.originalModel.Id && model.Id > 0) {
                return false;
            }

            Object.entries(this.originalModel).forEach((entity) => {
                var key = entity[0];
                var value = entity[1];

                if (key !== "VerifyFollowingProperlyJson" &&
                    key !== "Id" &&
                    model[key] !== value) {
                    changed = true;
                }
            });

            return changed;
        },
        setModel: function (name, val) {
            this.model[name] = val;
            this.forceUpdate();
            props.inputValueChanged();
        },
        forceUpdate: function () {
            setStep3({ ...step3, model: this.model });
        }

    });

    const [step4, setStep4] = useState({
        init: function () {
            this.model = JSON.parse(JSON.stringify(this.baseModel));
            this.setOriginalModel();
        },
        baseModel: {
            StepName: "step4",
            Id: 0,
            RDOAccountVisitId: 0,
            SectionId: 4,

            CrothallFinancialFollowUp: false,
            MOPCurrentPeriod: false,
            MOPCurrentPeriodNumber: null,//decimal ,from query
            YEForecast: false,
            YEForecastNumber: null,//decimal ,from query

            HospitalFinancialFollowUp: false,
            CurrentMonth: false,
            CurrentMonthNumber: null, //decimal
            CurrentMonthNumberCurrency: null,

            YTD: false,
            YTDNumber: null,//decimal
            YTDNumberCurrency: null,
            HospitalFinancialComments: null,

            ContractualAccountabilitieFollowUp: false,
            ContractualAccountabilitieIds: null,
            ContractualAccountabilitieJson: null,
            ContractualAccountabilitieComments: null,


            SectionComments: null,
            SectionComplete: false
        },
        model: {},
        originalModel: {},
        setOriginalModel: function () {
            this.originalModel = JSON.parse(JSON.stringify(this.model));
            setStep4({ ...step4, originalModel: this.originalModel });
        },
        fill: function (item) {
            this.model.Id = item.Id;
            this.model.RDOAccountVisitId = item.RDOAccountVisitId;
            this.model.CrothallFinancialFollowUp = item.CrothallFinancialFollowUp;
            if (item.CrothallFinancialFollowUp) setFollowUpList(...followUpList, '• Crothall Financials');
            this.model.MOPCurrentPeriod = item.MOPCurrentPeriod;
            this.model.MOPCurrentPeriodNumber = item.MOPCurrentPeriodNumber;
            this.model.YEForecast = item.YEForecast;
            this.model.YEForecastNumber = item.YEForecastNumber;

            this.model.HospitalFinancialFollowUp = item.HospitalFinancialFollowUp;
            if (item.HospitalFinancialFollowUp) setFollowUpList(...followUpList, '• Hospital Financials');
            this.model.CurrentMonth = item.CurrentMonth;
            this.model.CurrentMonthNumber = item.CurrentMonthNumber;

            this.model.YTD = item.YTD;
            this.model.YTDNumber = item.YTDNumber;

            this.model.HospitalFinancialComments = item.HospitalFinancialComments;

            this.model.ContractualAccountabilitieFollowUp = item.ContractualAccountabilitieFollowUp;
            if (item.ContractualAccountabilitieFollowUp) setFollowUpList(...followUpList, '• Contractual Accountabilities');
            this.model.ContractualAccountabilitieIds = item.ContractualAccountabilitieIds;
            this.model.ContractualAccountabilitieJson = item.ContractualAccountabilitieJson;
            this.model.ContractualAccountabilitieComments = item.ContractualAccountabilitieComments;


            this.model.SectionComments = item.SectionComments;
            this.model.SectionComplete = item.SectionComplete;

            if (item.ContractualAccountabilitieJson) {
                setContractualAccountabilitieTemplate(JSON.parse(item.ContractualAccountabilitieJson));
            }

            this.forceUpdate();
            this.setOriginalModel();
        },
        save: function () {

            var template = rdoClass.templates.ContractualAccountabilitieTemplate;

            this.model.ContractualAccountabilitieJson = JSON.stringify(template);

            saveRdoAccountVisitation();
        },
        checkModelChanged: function (_contractualAccountabilitieTemplate) {

            var template = _contractualAccountabilitieTemplate;

            setCheckValue(template, this.model, "ContractualAccountabilitieIds");
            this.model.ContractualAccountabilitieJson = JSON.stringify(template);

            var changed = false;
            var model = this.model;

            //if saved
            if (model.Id !== this.originalModel.Id && model.Id > 0) {
                return false;
            }

            Object.entries(this.originalModel).forEach((entity) => {
                var key = entity[0];
                var value = entity[1];

                if (key !== "ContractualAccountabilitieJson" &&
                    key !== "MOPCurrentPeriodNumber" &&
                    key !== "YEForecastNumber" &&
                    key !== "Id" &&
                    model[key] !== value) {
                    changed = true;
                }
            });

            return changed;
        },
        setModel: function (name, val) {
            this.model[name] = val;
            this.forceUpdate();
            props.inputValueChanged();
        },
        forceUpdate: function () {
            setStep4({ ...step4, model: this.model });
        }
    });

    const [step5, setStep5] = useState({
        init: function () {
            this.model = JSON.parse(JSON.stringify(this.baseModel));
            this.setOriginalModel();
        },
        baseModel: {
            StepName: "step5",
            Id: 0,
            RDOAccountVisitId: 0,
            SectionId: 5,
            ClicentFeedbackFollowUp: false,
            SectionComments: null,
            SectionComplete: false
        },
        model: {},
        originalModel: {},
        setOriginalModel: function () {
            this.originalModel = JSON.parse(JSON.stringify(this.model));
            setStep5({ ...step5, originalModel: this.originalModel });
        },
        fill: function (item) {
            this.model.Id = item.Id;
            this.model.ClicentFeedbackFollowUp = item.ClicentFeedbackFollowUp;
            if (item.ClicentFeedbackFollowUp) setFollowUpList(...followUpList, '• Client Feedback');
            this.model.SectionComments = item.SectionComments;
            this.model.SectionComplete = item.SectionComplete;
            this.model.RDOAccountVisitId = item.RDOAccountVisitId;
            this.forceUpdate();
            this.setOriginalModel();
        },
        save: function () {
            saveRdoAccountVisitation();
        },
        checkModelChanged: function () {
            var changed = false;
            var model = this.model;

            //if saved
            if (model.Id !== this.originalModel.Id && model.Id > 0) {
                return false;
            }

            Object.entries(this.originalModel).forEach((entity) => {
                var key = entity[0];
                var value = entity[1];

                if (key !== "Id" && model[key] !== value) {
                    changed = true;
                }
            });

            return changed;
        },
        setModel: function (name, val) {
            this.model[name] = val;
            this.forceUpdate();
            props.inputValueChanged();
        },
        forceUpdate: function () {
            setStep5({ ...step5, model: this.model });
        }
    });

    const showTeamCoach = (key) => {
        setIsShowTeamCoach(true);
        setCurrentTeamCoachKey(key);
    };

    const closeTeamCoach = (coachId) => {
        if (coachId !== undefined) {
            if (activeStep === 0) {
                step1.model.CompleteInterviewCoachFormIdArr.push(coachId);
                step1.model.CompleteInterviewCoachCompletedCount = step1.model.CompleteInterviewCoachFormIdArr.length;
                step1.model.CompleteInterviewCoachFormIds = step1.model.CompleteInterviewCoachFormIdArr.join(",");
                step1.forceUpdate();

            } else if (activeStep === 1) {
                step2.model[currentTeamCoachKey + "FormIdArr"].push(coachId);
                step2.model[currentTeamCoachKey + "CompletedCount"] = step2.model[currentTeamCoachKey + "FormIdArr"].length;
                step2.model[currentTeamCoachKey + "FormIds"] = step2.model[currentTeamCoachKey + "FormIdArr"].join(",");
                step2.forceUpdate();
            }
            saveRdoAccountVisitation(true);
            setSuccessMessage("TeamCoach Form ID: " + coachId + " has been completed successfully.");
            setOpenSuccess(true);
        }
        setIsShowTeamCoach(false);
    };

    const TransactionTimeStart = () => {
        setShowInactiveMessage(true);
        TransactionTime.begin('rdoAccountVisitationEdit');
    };

    const onPageChange = () => {
        setShowInactiveMessage(false);
        TransactionTime.cancel();

        if (activeStep === 0) {
            if (!step1.model.Id) {
                TransactionTimeStart();
            }
        }
        else if (activeStep === 1) {
            if (!step2.model.Id) {
                var model = step2.model;
                model.HCAHPSResults = rdoParameters.HCHAPSScore;
                model.RTC60Compliance = rdoParameters.RTC60MinPct;
                model.LaborOpCapacity = rdoParameters.LaborOpCap;
                model.CleaningQAs = rdoParameters.CleaningQAs;
                model.CustomerRounds = rdoParameters.CustomerRounds;

                //Reassign Parameters
                model.CleaningQAsYTDScore = "";
                model.CleaningQAsSurveyTitle = "";

                if (rdoParameters.CleaningQAs && rdoParameters.CleaningQAs.length > 0) {
                    rdoParameters.CleaningQAs.forEach(function (value, key) {
                        model.CleaningQAsYTDScore += value + ",";
                        model.CleaningQAsSurveyTitle += key + ",";
                    });
                }

                if (model.CleaningQAsYTDScore) {
                    model.CleaningQAsYTDScore = model.CleaningQAsYTDScore.substring(0, model.CleaningQAsYTDScore.length - 1);
                }

                if (model.CleaningQAsSurveyTitle) {
                    model.CleaningQAsSurveyTitle = model.CleaningQAsSurveyTitle.substring(0, model.CleaningQAsSurveyTitle.length - 1);
                }

                model.PEObservations = rdoParameters.PEObservations;

                step2.forceUpdate();
                TransactionTimeStart();
            }

        }
        else if (activeStep === 2) {

            if (!step3.model.Id) {
                TransactionTimeStart();
            }
        }
        else if (activeStep === 3) {
            if (!step4.model.Id) {
                step4.model.MOPCurrentPeriodNumber = rdoParameters.MOPCurrentPeriod;
                step4.model.YEForecastNumber = rdoParameters.YEForecast;
                step4.forceUpdate();
                TransactionTimeStart();
            }

        }
        else if (activeStep === 4) {

            if (!step5.model.Id) {
                TransactionTimeStart();
            }
        }
    };

    useImperativeHandle(ref, () => {
        return {
            save: cancel
        };
    });

    const handleStep = (index) => {
        setActiveStep(index);
    };

    const cancel = () => {

        var checkUnsaved = false;
        var message = "";
        var _UnSavedIndexStep = -1;
        if (step1.checkModelChanged()) {
            checkUnsaved = true;
            message += "'Client Engagement',";
            _UnSavedIndexStep = 0;
        }

        if (step2.checkModelChanged(housekeepingCartTemplate)) {
            checkUnsaved = true;
            message += "'Purposeful Rounding',";
            _UnSavedIndexStep = _UnSavedIndexStep === -1 ? 1 : _UnSavedIndexStep;
        }

        if (step3.checkModelChanged(verifyFollowingProperlyTemplate)) {
            checkUnsaved = true;
            message += "'Operational Integrity',";
            _UnSavedIndexStep = _UnSavedIndexStep === -1 ? 2 : _UnSavedIndexStep;
        }

        if (step4.checkModelChanged(contractualAccountabilitieTemplate)) {
            checkUnsaved = true;
            message += "'Financial Stewardship',";
            _UnSavedIndexStep = _UnSavedIndexStep === -1 ? 3 : _UnSavedIndexStep;
        }

        if (step5.checkModelChanged()) {
            checkUnsaved = true;
            message += "'Observation & Notes',";
            _UnSavedIndexStep = _UnSavedIndexStep === -1 ? 4 : _UnSavedIndexStep;
        }

        if (checkUnsaved) {

            message += "has not been saved. Are you sure you want to leave this page?";

            setComfirmMessage(message);
            setUnSavedIndexStep(_UnSavedIndexStep);
            setIsShowComfirm(true);
        }
        else
            props.parentCallback();
    }

    const closeErrorSnackbar = () => {
        setOpenError(false);
    };

    const setCheckValue = (list, obj, key) => {
        //clear
        obj[key] = "";

        list.forEach((item) => {
            if (item.Checked) {
                obj[key] += item.CodeId + ",";
            }
        });

        if (obj[key] === "") {
            obj[key] = null;
        }
    };

    const dialogConfirm = () => {
        dialogClose();
    };

    const dialogClose = () => {
        setOpenDialog(false);
    };

    const saveDirectorRdo = () => {

        if (rdoClass.model.Id > 0) {
            setBackDrop(true);
            HttpService.post('/RDOAccountVisitation/SaveDirectorRDO', { parentDto: rdoClass.model })
                .then((result) => {
                    setBackDrop(false);
                    if (result.error) {
                        return;
                    }
                },
                    (error) => {
                        console.log(error);
                        setBackDrop(false);
                    });
        }

        setIsShowDirectorRdo(false);
    };

    const getCoachId = () => {
        setBackDrop(true);
        HttpService.post('/TeamCoach/GetIntegratedSystem', {
            GeoLocationId: defaultSite.id
        })
            .then((result) => {
                if (result && result.offline) {
                    //get offline data
                    return;
                }

                if (Number(result.data.TeamCoachId) > 0) {
                    setTeamCoachId(Number(result.data.TeamCoachId));
                }

                setBackDrop(false);
            },
                (error) => {
                    console.log(error);
                    setBackDrop(false);
                });
    };

    const getHirnode = () => {

        if (activeStep === 0)
            return step1.model.Hirnode;
        else
            return null;
    };

    const saveRdoAccountVisitation = (stayHere) => {

        var stepModel = {};
        var template = null;

        if (activeStep === 0) {
            stepModel = step1.model;
        }
        else if (activeStep === 1) {
            template = housekeepingCartTemplate;
            setCheckValue(template, step2.model, "HousekeepingCartIds");
            step2.model.HousekeepingCartJson = JSON.stringify(template);
            stepModel = step2.model;
        }
        else if (activeStep === 2) {
            template = verifyFollowingProperlyTemplate;
            setCheckValue(template, step3.model, "VerifyFollowingProperlyIds");
            step3.model.VerifyFollowingProperlyJson = JSON.stringify(template);
            stepModel = step3.model;
        }
        else if (activeStep === 3) {
            template = contractualAccountabilitieTemplate;
            setCheckValue(template, step4.model, "ContractualAccountabilitieIds");
            step4.model.ContractualAccountabilitieJson = JSON.stringify(template);
            stepModel = step4.model;
        }
        else if (activeStep === 4) {
            stepModel = step5.model;
        }

        var model = { RDOAccountVisitDto: rdoClass.model, RDOAccountVisitSectionDto: stepModel };

        TransactionTime.end();
        TransactionTime.updateData(model.RDOAccountVisitSectionDto);
        TransactionTime.cancel();
        setCanSave(false);
        HttpService.post('/RDOAccountVisitation/SaveRDOSection',
            model
        )
            .then(async (result) => {
                setBackDrop(false);
                var nextSection = 0;

                if (result && result.offline) {

                    if (model.RDOAccountVisitDto.Id === 0) {
                        let newId = Number((Date.now()).toString().substring(0, 12));
                        model.RDOAccountVisitDto.Id = newId;
                        model.RDOAccountVisitDto.RDOAccountVisitSectionList.push(stepModel);
                    }
                    else {
                        var exist = false;
                        model.RDOAccountVisitDto.RDOAccountVisitSectionList.forEach((x, index) => {
                            if (x.SectionId === stepModel.SectionId) {
                                //x = stepModel;
                                model.RDOAccountVisitDto.RDOAccountVisitSectionList[index] = stepModel;
                                exist = true;
                            }
                        });

                        if (!exist)
                            model.RDOAccountVisitDto.RDOAccountVisitSectionList.push(stepModel);
                    }

                    model.RDOAccountVisitDto.CreatedDateTimeString = ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY HH:mm:ss", null, defaultSite);
                    model.RDOAccountVisitDto.SiteName = defaultSite.name;
                    model.RDOAccountVisitDto.IsOfflineSync = true;
                    model.RDOAccountVisitDto.RDORating = step2.model.RDOAccountRating;
                    model.RDOAccountVisitDto.SectionsCompleted = 0;
                    setRdoClass({ ...rdoClass, model: model.RDOAccountVisitDto });

                    if (step1.model.SectionComplete) model.RDOAccountVisitDto.SectionsCompleted++;
                    if (step2.model.SectionComplete) model.RDOAccountVisitDto.SectionsCompleted++;
                    if (step3.model.SectionComplete) model.RDOAccountVisitDto.SectionsCompleted++;
                    if (step4.model.SectionComplete) model.RDOAccountVisitDto.SectionsCompleted++;
                    if (step5.model.SectionComplete) model.RDOAccountVisitDto.SectionsCompleted++;

                    if (model.RDOAccountVisitSectionDto.Id === 0) {
                        model.RDOAccountVisitSectionDto.Id = Number((Date.now()).toString().substring(0, 12));
                    }

                    model.RDOAccountVisitSectionDto.RDOAccountVisitId = model.RDOAccountVisitDto.Id;

                    if (activeStep === 0) {
                        step1.fill(model.RDOAccountVisitSectionDto);
                    }
                    else if (activeStep === 1) {
                        step2.fill(model.RDOAccountVisitSectionDto);
                    }
                    else if (activeStep === 2) {
                        step3.fill(model.RDOAccountVisitSectionDto);
                    }
                    else if (activeStep === 3) {
                        step4.fill(model.RDOAccountVisitSectionDto);
                    }
                    else if (activeStep === 4) {
                        step5.fill(model.RDOAccountVisitSectionDto);
                    }

                    // if created from offline then Store only RDOAccountVisitDto recode else store multiple RDOAccountVisitSectionDto one by one
                    var entityId = model.RDOAccountVisitDto.IsOfflineSync ? model.RDOAccountVisitDto.Id : model.RDOAccountVisitSectionDto.Id;

                    await SaveRDOSectionOfflineData(defaultSite.id, entityId, "SaveRDOSection", model, "/RDOAccountVisitation/SaveRDOSection", false, false);

                    nextSection = activeStep === 4 ? -1 : activeStep + 1;
                }
                else if (result.error) {
                    return;
                }
                else {
                    await SaveRDOSectionOfflineData(defaultSite.id, result.dto.RDOAccountVisitSectionModel.Id, "SaveRDOSection", { RDOAccountVisitDto: result.dto.RDOAccountVisitModel, RDOAccountVisitSectionDto: result.dto.RDOAccountVisitSectionModel }, "/RDOAccountVisitation/SaveRDOSection", true, false);

                    if (result.dto.RDOAccountVisitModel.DraftSave === true || rdoClass.returnedFromCoach === true) {
                        setRdoClass({ ...rdoClass, returnedFromCoach: false });
                        return;
                    }

                    result.dto.RDOAccountVisitModel.Account = rdoClass.model.Account;
                    result.dto.RDOAccountVisitModel.AccountVisitDate = rdoClass.model.AccountVisitDate;
                    setRdoClass({ ...rdoClass, model: result.dto.RDOAccountVisitModel });

                    nextSection = result.dto.NextSection > 0 ? result.dto.NextSection - 1 : result.dto.NextSection;

                    var sItem = result.dto.RDOAccountVisitSectionModel;

                    if (sItem.SectionId === 1) {
                        step1.fill(sItem);
                    }
                    else if (sItem.SectionId === 2) {
                        step2.fill(sItem);
                    }
                    else if (sItem.SectionId === 3) {
                        step3.fill(sItem);
                    }
                    else if (sItem.SectionId === 4) {
                        step4.fill(sItem);
                    }
                    else if (sItem.SectionId === 5) {
                        step5.fill(sItem);
                    }
                }

                setCanSave(true);
                if (stayHere) return; // don't move to next tab

                if (nextSection !== -1) {
                    setActiveStep(nextSection);
                }
                else {
                    cancel();
                }

            },
                (error) => {
                    console.log(error);
                    setBackDrop(false);
                    setCanSave(true);
                });

    };

    const getRDOAccountVisitTemplate = () => {
        setBackDrop(true);
        HttpService.post('/RDOAccountVisitation/GetRDOAccountVisitTemplate')
            .then(async (result) => {
                setBackDrop(false);
                if (result && result.offline) {
                    //get offline data
                    const offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "GetRDOAccountVisitTemplate");
                    setRdoSectionOptionsBase(offlineResult.OfflineData);
                }
                else if (result.error) {
                    return;
                }
                else {
                    setRdoSectionOptionsBase(result.rdoSectionOptionTemplate || []);
                }

            },
                (error) => {
                    console.log(error);
                    setBackDrop(false);
                });

    };

    const getRDOParameters = (visitDate) => {
        setBackDrop(true);
        HttpService.post('/RDOAccountVisitation/GetRDOParameters', { HouseCode: Number(defaultSite.houseCode[0]), VisitDate: visitDate })
            .then(async (result) => {
                setBackDrop(false);
                if (result && result.offline) {
                    //get offline data
                    const offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "GetRDOParameters");
                    setRdoParameters(offlineResult.OfflineData);
                }
                else if (result.error) {
                    return;
                }
                else {
                    setRdoParameters(result.rdoParameter || []);
                }
            },
                (error) => {
                    console.log(error);
                    setBackDrop(false);
                });

    };

    const getRDOAndDirector = () => {
        setBackDrop(true);
        HttpService.post('/RDOAccountVisitation/GetRDOAndDirector',
            {
                HouseCode: Number(defaultSite.houseCode[0])
            }
        )
            .then(async (result) => {
                setBackDrop(false);
                if (result && result.offline) {
                    //get offline data
                    const offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "GetRDOAndDirector");
                    setRdoClass({ ...rdoClass, model: { ...rdoClass.model, Director: offlineResult.OfflineData?.Director, RDO: offlineResult.OfflineData?.RDO } });
                }
                else if (result.error) {
                    return;
                }
                else {
                    setRdoClass({ ...rdoClass, model: { ...rdoClass.model, Director: result.rdoDirector?.Director, RDO: result.rdoDirector?.RDO } });
                }

            },
                (error) => {
                    console.log(error);
                    setBackDrop(false);
                });

    };

    const getRDOSections = () => {
        setBackDrop(true);

        HttpService.post('/RDOAccountVisitation/GetRDOSections',
            rdoClass.model

        )
            .then(async (result) => {
                setBackDrop(false);
                if (result && result.offline) {
                    //get offline data
                    const offlineResult = await GetRDOSections(defaultSite.id, rdoClass.model.Id);
                    fillManipulateSection(offlineResult);
                }
                else if (result.error) {
                    return;
                }
                else {
                    fillManipulateSection(result.RDOAccountVisitSectionList);
                }

            },
                (error) => {
                    console.log(error);
                    setBackDrop(false);
                });

    };

    const getApiHirnodesFlattenedFullHirnodeBySite = function (callback) {

        HttpService.post('/TeamCoach/GetApiHirnodesFlattenedFullHirnodeBySite',
            { teamCoachId: teamCoachIdRef.current + '' }

        )
            .then((result) => {
                setBackDrop(false);
                if (result && result.offline) {
                    //get offline data
                }
                else if (result.error) {
                    return;
                }
                else {
                    step1.model.Hirnode = result.data.Hirnode;
                    step1.forceUpdate();
                    if (callback) callback();
                }

            },
                (error) => {
                    console.log(error);
                    setBackDrop(false);
                });

    };

    const fillManipulateSection = (sections) => {

        sections.forEach(function (sitem) {
            if (sitem.SectionId === 1) {
                step1.fill(sitem);
            }
            else if (sitem.SectionId === 2) {
                step2.fill(sitem);
            }
            else if (sitem.SectionId === 3) {
                step3.fill(sitem);
            }
            else if (sitem.SectionId === 4) {
                step4.fill(sitem);
            }
            else if (sitem.SectionId === 5) {
                step5.fill(sitem);
            }
        });
        setRdoClass({ ...rdoClass, model: { ...rdoClass.model, RDOAccountVisitSectionList: sections } });
        setActiveStep(0);
    }

    const setTemplate = () => {
        var _rdoSectionOptions = JSON.parse(JSON.stringify(rdoSectionOptionsBase));

        setHousekeepingCartTemplate(_rdoSectionOptions.filter(x => x.GroupId === 1));
        setVerifyFollowingProperlyTemplate(_rdoSectionOptions.filter(x => x.GroupId === 2));
        setContractualAccountabilitieTemplate(_rdoSectionOptions.filter(x => x.GroupId === 3));
    };

    const onConfirmCancel = () => {
        if (unSavedIndexStep !== -1)
            setActiveStep(unSavedIndexStep);

        setIsShowComfirm(false);
    };

    useEffect(() => {
        setTemplate();
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rdoSectionOptionsBase]);

    useEffect(() => {
        getRDOAccountVisitTemplate();
        getCoachId();
        rdoClass.init(action);
        if (action === "Edit") {
            rdoClass.fill(rdoAccountVisitationSelected);
            getRDOSections();
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        teamCoachIdRef.current = teamCoachId;
    }, [teamCoachId]);

    useEffect(() => {
        onPageChange();
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeStep]);


    return (<>
        {
            !isRdoDirectorActionAdd &&
            <>
                <Backdrop className={classes.backdrop} id="backdrop" open={backDrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Snackbar open={openSuccess} autoHideDuration={3000} onClose={closeSuccessSnackbar} style={{ height: "100%" }}>
                    <Alert onClose={closeSuccessSnackbar} severity="success">
                        {successMessage}
                    </Alert>
                </Snackbar>
                <Snackbar open={openError} autoHideDuration={3000} onClose={closeErrorSnackbar} style={{ height: "100%" }}>
                    <Alert onClose={closeErrorSnackbar} severity="error">
                        {errorMessage}
                    </Alert>
                </Snackbar>
                <ConfirmDialog open={isShowComfirm} title='Confirm' onConfirm={() => { props.parentCallback() }} close={onConfirmCancel} message={comfirmMessage}></ConfirmDialog>
                <ContentDialog open={isShowDirectorRdo} title="DIRECTOR & RDO" maxWidth={"lg"} close={() => setIsShowDirectorRdo(false)} onConfirm={saveDirectorRdo} >
                    <TextField size="small" fullWidth
                        label="Director"
                        variant="outlined"
                        value={rdoClass.model?.Director || ""}
                        onChange={(e) => { setRdoClass({ ...rdoClass, model: { ...rdoClass.model, Director: e.target.value } }) }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    <TextField size="small" fullWidth
                        label="RDO"
                        variant="outlined"
                        className={classes.mt10}
                        value={rdoClass.model?.RDO || ""}
                        onChange={(e) => { setRdoClass({ ...rdoClass, model: { ...rdoClass.model, RDO: e.target.value } }) }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </ContentDialog>
                <Dialog zindex="100" fullScreen open={isShowTeamCoach} disableBackdropClick={true} disableEscapeKeyDown={true}>
                    <DialogContent dividers>
                        <TeamCoachList goToComeFrom={closeTeamCoach} comeFrom={"RDOAccountVisitation"} rodTab={activeStep === 0 ? 'Tab1' : ''} getHirnode={getHirnode} />
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained"
                            color="secondary"
                            size="small"
                            className={classes.button}
                            style={{ width: "100px", marginRight: "60px" }}
                            onClick={e => closeTeamCoach()}
                            startIcon={<CancelIcon />}
                        >
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
                <AlertDialog handleClose={dialogClose} handlePositive={dialogConfirm} open={openDialog} message={''} buttonName="Confirm"></AlertDialog>
                <div className={classes.root} autoComplete="off">
                    <Grid container
                        direction="row"
                        justify="space-between"
                        alignItems="center"
                        spacing={1}
                    >
                        <Grid container item sm={12} justify="center">
                            <Link
                                href={'https://reports.crothall.com/ReportServer/Pages/ReportViewer.aspx?%2fApplications%2fTeamFin_SAP%2fTeamFin_EVS%2fTeamFin_EVS_ULED&rs:Command=Render'}
                                target="_black"
                            >
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    className={classes.button}
                                    style={{ background: currentTheme.secondary, width: "150px", marginLeft: "10px" }}
                                >
                                    ULED/ULCD
                                </Button>
                            </Link>

                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                className={classes.button}
                                disabled={rdoClass.model.SectionsCompleted !== 5}
                                style={{ background: currentTheme.secondary, width: "150px", marginLeft: "10px" }}
                                onClick={() => { setIsRdoDirectorActionAdd(true); }}
                            >
                                Director Action
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid container
                        direction="row"
                        justify="space-between"
                        alignItems="flex-start"
                        spacing={1}>
                        <Grid container item sm={12} onClick={() => setIsShowDirectorRdo(true)}>
                            <Typography variant="body2" gutterBottom>
                                DIRECTOR: {rdoClass.model?.Director || ""}
                            </Typography>
                            &nbsp;&nbsp;
                            <Typography variant="body2" gutterBottom>
                                RDO: {rdoClass.model?.RDO || ""}
                            </Typography>
                        </Grid>
                    </Grid>
                    <ValidatorForm className={classes.root} autoComplete="off" onSubmit={saveRdoAccountVisitation} reflectchanges={reflect.toString()}>

                        <Stepper alternativeLabel activeStep={activeStep} connector={<QontoConnector />} style={{ backgroundColor: 'transparent' }} >
                            {stepTitles.map((title, index) => (
                                <Step key={title}>
                                    <StepLabel StepIconComponent={QontoStepIcon} onClick={() => { handleStep(index) }}>{title}</StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                        <div>
                            {
                                activeStep === 0 &&
                                <>
                                    <Grid container
                                        direction="row"
                                        justify="center"
                                        alignItems="center"
                                        spacing={1}
                                    >
                                        <Grid item sm={4}>
                                            <Button variant="contained" className={`${classes.flButton} ${classes.green}`} onClick={() => { step1.setModel("CompleteInterviewFollowUp", !step1.model?.CompleteInterviewFollowUp) }}>

                                                <Checkbox
                                                    checked={step1.model?.CompleteInterviewFollowUp || false}
                                                    style={{ color: 'white' }}
                                                    onChange={(e) => { step1.setModel("CompleteInterviewFollowUp", e.target.checked); }}
                                                />
                                                Follow Up
                                            </Button>
                                        </Grid>
                                        <Grid item sm={8}>
                                            <span className={classes.textBlod}>
                                                Complete interviews with direct client and additional key contacts within C-suite and Procurement
                                            </span>
                                        </Grid>
                                        <Grid item container sm={12} justify="center" alignItems="center">
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                size="small"
                                                className={classes.button}
                                                style={{ background: currentTheme.secondary, width: "120px", marginLeft: "20px" }}
                                                onClick={() => { step1.onTeamCoach(); }}>
                                                teamCoach
                                            </Button>
                                            &nbsp;
                                            {
                                                step1.model.CompleteInterviewCoachCompletedCount > 0 &&

                                                <Chip label={step1.model.CompleteInterviewCoachCompletedCount} className={classes.chip} />
                                            }
                                        </Grid>
                                        <Grid item sm={12}>
                                            <TextField size="small" fullWidth
                                                multiline
                                                rows="4"
                                                label="Section Comments"
                                                variant="outlined"
                                                value={step1.model?.SectionComments || ""}
                                                className={classes.mt10}
                                                onChange={(e) => { step1.setModel("SectionComments", e.target.value); }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item sm={12}>
                                            <FormControlLabel
                                                label="Section Complete?"
                                                control={
                                                    <Checkbox
                                                        checked={step1.model?.SectionComplete || false}
                                                        onChange={(e) => { step1.setModel("SectionComplete", e.target.checked); }}
                                                        value="checkedA"
                                                    />
                                                }
                                                style={{ color: currentTheme.text }}
                                                labelPlacement="start"
                                            />
                                        </Grid>
                                    </Grid>
                                </>
                            }
                            {
                                activeStep === 1 &&
                                <>
                                    <Grid container
                                        direction="row"
                                        justify="center"
                                        alignItems="center"
                                        spacing={1}
                                    >
                                        <Grid item sm={4}>
                                            <Button variant="contained" className={`${classes.flButton} ${classes.green}`} onClick={() => { step2.setModel("QAInspectionHPUFollowUp", !step2.model?.QAInspectionHPUFollowUp) }}>

                                                <Checkbox
                                                    checked={step2.model?.QAInspectionHPUFollowUp || false}
                                                    style={{ color: 'white' }}
                                                    onChange={(e) => { step2.setModel("QAInspectionHPUFollowUp", e.target.checked); }}
                                                />
                                                Follow Up
                                            </Button>
                                        </Grid>
                                        <Grid item sm={8}>
                                            <span variant="title" className={classes.textBlod}>
                                                Conduct at least two QA Inspections on High Priority Units.
                                            </span>
                                        </Grid>
                                        <Grid item container sm={12} justify="center">
                                            <Button variant="contained" color="primary" size="small" className={classes.button} style={{ background: currentTheme.secondary, width: "120px" }} onClick={() => { step2.onTeamCoach('QAInspectionHPUCoach'); }}>
                                                teamCoach
                                            </Button>
                                            &nbsp;
                                            {
                                                step2.model.QAInspectionHPUCoachCompletedCount > 0 &&
                                                <Chip label={step2.model.QAInspectionHPUCoachCompletedCount} className={classes.chip} />
                                            }
                                        </Grid>

                                        {/* ---Grid--- */}
                                        <Grid item sm={4}>
                                            <Button variant="contained" className={`${classes.flButton} ${classes.green}`} onClick={() => { step2.setModel("QAInspectionHCAHPSFollowUp", !step2.model?.QAInspectionHCAHPSFollowUp) }}>

                                                <Checkbox
                                                    checked={step2.model?.QAInspectionHCAHPSFollowUp || false}
                                                    style={{ color: 'white' }}
                                                    onChange={(e) => { step2.setModel("QAInspectionHCAHPSFollowUp", e.target.checked); }}
                                                />
                                                Follow Up
                                            </Button>
                                        </Grid>
                                        <Grid item sm={8}>
                                            <span variant="title" className={classes.textBlod}>
                                                Conduct at least two additional QA Inspections to validate HPC compliance and knowledge of HCAHPS
                                            </span>
                                        </Grid>
                                        {/* ---Grid--- */}
                                        <Grid item container sm={12} justify="center">
                                            <Button variant="contained" color="primary" size="small" className={classes.button} style={{ background: currentTheme.secondary, width: "120px" }} onClick={() => { step2.onTeamCoach('QAInspectionHCAHPSCoach'); }}>
                                                teamCoach
                                            </Button>
                                            &nbsp;
                                            {
                                                step2.model.QAInspectionHCAHPSCoachCompletedCount > 0 &&
                                                <Chip label={step2.model.QAInspectionHCAHPSCoachCompletedCount} className={classes.chip} />
                                            }
                                        </Grid>
                                        {/* ---Grid--- */}
                                        <Grid item sm={4}>
                                            <Button variant="contained" className={`${classes.flButton} ${classes.green}`} onClick={() => { step2.setModel("HousekeepingCartFollowUp", !step2.model?.HousekeepingCartFollowUp) }}>

                                                <Checkbox
                                                    checked={step2.model?.HousekeepingCartFollowUp || false}
                                                    style={{ color: 'white' }}
                                                    onChange={(e) => { step2.setModel("HousekeepingCartFollowUp", e.target.checked); }}
                                                />
                                                Follow Up
                                            </Button>
                                        </Grid>
                                        <Grid item sm={8}>
                                            <span variant="title" className={classes.textBlod}>
                                                Janitor Closet and Housekeeping Cart Compliance
                                            </span>
                                            <br />
                                            <span variant="caption">
                                                Check only those items evaluated and found to be compliant
                                            </span>
                                        </Grid>
                                        {/* ---Grid--- */}
                                        <Grid item sm={4} ></Grid>
                                        <Grid item container sm={8} spacing={2}>
                                            <Grid item>
                                                {
                                                    housekeepingCartTemplate.filter((x, rowIndex) => rowIndex % 2 === 0).map((item, index) => {
                                                        return (
                                                            <div key={item.Id + '-' + index}>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            onChange={(e) => { item.Checked = e.target.checked; step2.forceUpdate(); }}
                                                                            checked={item.Checked}
                                                                        />
                                                                    }
                                                                    label={item.Option}
                                                                    style={{ color: currentTheme.text }}
                                                                />
                                                                <br />
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </Grid>
                                            <Grid item>
                                                {
                                                    housekeepingCartTemplate.filter((x, rowIndex) => rowIndex % 2 !== 0).map((item) => {
                                                        return (
                                                            <div key={item.Id}>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            onChange={(e) => { item.Checked = e.target.checked; step2.forceUpdate(); }}
                                                                            checked={item.Checked}
                                                                        />
                                                                    }
                                                                    label={item.Option}
                                                                    style={{ color: currentTheme.text }}
                                                                />
                                                                <br />
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </Grid>
                                        </Grid>
                                        {/* ---Grid--- */}
                                        <Grid item sm={4}>
                                            <Button variant="contained" className={`${classes.flButton} ${classes.green}`} onClick={() => { step2.setModel("OverallAccountAssessmentFollowUp", !step2.model?.OverallAccountAssessmentFollowUp) }} >

                                                <Checkbox
                                                    checked={step2.model?.OverallAccountAssessmentFollowUp || false}
                                                    style={{ color: 'white' }}
                                                    onChange={(e) => { step2.setModel("OverallAccountAssessmentFollowUp", e.target.checked); }}
                                                />
                                                Follow Up
                                            </Button>
                                        </Grid>
                                        <Grid item sm={8}>
                                            <span variant="title" className={classes.textBlod}>
                                                Overall Account Assessment
                                            </span>
                                        </Grid>
                                        {/* ---Grid--- */}
                                        <Grid item sm={4} ></Grid>
                                        <Grid item container sm={8} spacing={2}>
                                            <Grid item>
                                                <label variant="caption" style={{ color: currentTheme.text }}>
                                                    Customer Rounds - {step2.model.CustomerRounds}
                                                </label><br />
                                                <label variant="caption" style={{ color: currentTheme.text }}>
                                                    PE Observations - {step2.model.PEObservations}
                                                </label><br />
                                                <label variant="caption" style={{ color: currentTheme.text }}>
                                                    Cleaning QAs  -
                                                </label>

                                            </Grid>
                                            <Grid item>
                                                <label variant="caption" style={{ color: currentTheme.text }}>
                                                    Labor Op Capacity - {step2.model.LaborOpCapacity}
                                                </label><br />
                                                <label variant="caption" style={{ color: currentTheme.text }}>
                                                    HCAHPS Results - {step2.model.HCAHPSResults}
                                                </label><br />
                                                <label variant="caption" style={{ color: currentTheme.text }}>
                                                    RTC60 Compliance  - {step2.model.RTC60Compliance}
                                                </label>
                                            </Grid>
                                        </Grid>
                                        {/* ---Grid--- */}
                                        <Grid item container sm={12} justify="center" alignItems="center" spacing={2}>
                                            <Grid item container sm={6} alignItems="center">
                                                <label className={classes.textBlod} style={{ color: currentTheme.text }}>
                                                    RDO Account Rating
                                                </label>

                                                <label variant="caption" style={{ color: currentTheme.text }}>
                                                    &nbsp;  &nbsp;  <small className={classes.textBlod}>Lowest</small>  &nbsp;
                                                </label>
                                                <RadioGroup
                                                    row
                                                    name="RDO-Accounting-Rating"
                                                    value={step2.model.RDOAccountRating + ""}
                                                    onChange={(e) => { step2.setModel("RDOAccountRating", Number(e.target.value)); }}
                                                >
                                                    <FormControlLabel
                                                        value="1"
                                                        control={<Radio color="primary" />}
                                                        label="1"
                                                        style={{ color: currentTheme.text }}
                                                    />
                                                    <FormControlLabel
                                                        value="2"
                                                        control={<Radio color="primary" />}
                                                        label="2"
                                                        style={{ color: currentTheme.text }}
                                                    />
                                                    <FormControlLabel
                                                        value="3"
                                                        control={<Radio color="primary" />}
                                                        label="3"
                                                        style={{ color: currentTheme.text }}
                                                    />
                                                    <FormControlLabel
                                                        value="4"
                                                        control={<Radio color="primary" />}
                                                        label="4"
                                                        style={{ color: currentTheme.text }}
                                                    />
                                                    <FormControlLabel
                                                        value="5"
                                                        control={<Radio color="primary" />}
                                                        label="5"
                                                        style={{ color: currentTheme.text }}
                                                    />
                                                </RadioGroup>

                                                <label variant="caption" style={{ color: currentTheme.text }}>
                                                    <small className={classes.textBlod}>Highest</small>
                                                </label>
                                            </Grid>
                                        </Grid>
                                        {/* ---Grid--- */}
                                        <Grid item sm={12}>
                                            <TextField size="small" fullWidth
                                                multiline
                                                rows="4"
                                                label="RDO Rating Comments"
                                                variant="outlined"
                                                value={step2.model?.RDORatingComments || ""}
                                                className={classes.mt10}
                                                onChange={(e) => { step2.setModel("RDORatingComments", e.target.value); }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item sm={12}>
                                            <TextField size="small" fullWidth
                                                multiline
                                                rows="4"
                                                label="Section Comments"
                                                variant="outlined"
                                                value={step2.model?.SectionComments || ""}
                                                className={classes.mt10}
                                                onChange={(e) => { step2.setModel("SectionComments", e.target.value); }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item sm={12}>
                                            <FormControlLabel
                                                label="Section Complete?"
                                                control={
                                                    <Checkbox
                                                        checked={step2.model?.SectionComplete || false}
                                                        onChange={(e) => { step2.setModel("SectionComplete", e.target.checked); }}
                                                        value="checkedA"
                                                    />
                                                }
                                                style={{ color: currentTheme.text }}
                                                labelPlacement="start"
                                            />
                                        </Grid>
                                    </Grid>
                                </>
                            }
                            {
                                activeStep === 2 &&
                                <>
                                    <Grid container
                                        direction="row"
                                        justify="center"
                                        alignItems="center"
                                        spacing={1}
                                    >
                                        <Grid item sm={4}>
                                            <Button variant="contained" className={`${classes.flButton} ${classes.green}`} onClick={() => { step3.setModel("VerifyFollowingProperlyFollowUp", !step3.model?.VerifyFollowingProperlyFollowUp) }} >

                                                <Checkbox
                                                    checked={step3.model?.VerifyFollowingProperlyFollowUp || false}
                                                    style={{ color: 'white' }}
                                                    onChange={(e) => { step3.setModel("VerifyFollowingProperlyFollowUp", e.target.checked); }}
                                                    value="checkedA"
                                                />
                                                Follow Up
                                            </Button>
                                        </Grid>
                                        <Grid item sm={8}>
                                            <span variant="title" className={classes.textBlod}>
                                                Verify the following are properly maintained, utilized correctly, and fully compliant
                                            </span>
                                            <br />
                                            <span variant="caption">
                                                Check only those items evaluated and found to be compliant
                                            </span>
                                        </Grid>
                                        {/* ---Grid--- */}
                                        <Grid item sm={4} ></Grid>
                                        <Grid item container sm={8} spacing={2}>
                                            <Grid item>
                                                {
                                                    verifyFollowingProperlyTemplate.filter((x, rowIndex) => rowIndex % 2 === 0).map((item, index) => {
                                                        return (
                                                            <div key={item.Id + '-' + index}>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            onChange={(e) => { item.Checked = e.target.checked; step3.forceUpdate(); }}
                                                                            checked={item.Checked}
                                                                        />
                                                                    }
                                                                    label={item.Option}
                                                                    style={{ color: currentTheme.text }}
                                                                />
                                                                <br />
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </Grid>
                                            <Grid item>
                                                {
                                                    verifyFollowingProperlyTemplate.filter((x, rowIndex) => rowIndex % 2 !== 0).map((item) => {
                                                        return (
                                                            <div key={item.Id}>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            onChange={(e) => { item.Checked = e.target.checked; step3.forceUpdate(); }}
                                                                            checked={item.Checked}
                                                                        />
                                                                    }
                                                                    label={item.Option}
                                                                    style={{ color: currentTheme.text }}
                                                                />
                                                                <br />
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </Grid>
                                        </Grid>
                                        {/* ---Grid--- */}
                                        <Grid item sm={12}>
                                            <TextField size="small" fullWidth
                                                multiline
                                                rows="4"
                                                label="Section Comments"
                                                variant="outlined"
                                                value={step3.model?.SectionComments || ""}
                                                className={classes.mt10}
                                                onChange={(e) => { step3.setModel("SectionComments", e.target.value); }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </Grid>
                                        {/* ---Grid--- */}
                                        <Grid item sm={12}>
                                            <FormControlLabel
                                                label="Section Complete?"
                                                control={
                                                    <Checkbox
                                                        checked={step3.model?.SectionComplete || false}
                                                        onChange={(e) => { step3.setModel("SectionComplete", e.target.checked); }}
                                                        value="checkedA"
                                                    />
                                                }
                                                style={{ color: currentTheme.text }}
                                                labelPlacement="start"
                                            />
                                        </Grid>
                                    </Grid>
                                </>
                            }
                            {
                                activeStep === 3 &&
                                <>
                                    <Grid container
                                        direction="row"
                                        justify="center"
                                        alignItems="center"
                                        spacing={1}
                                    >
                                        <Grid item sm={2}></Grid>
                                        <Grid item sm={2}>
                                            <Button variant="contained" className={`${classes.flButton} ${classes.green}`} onClick={() => { step4.setModel("CrothallFinancialFollowUp", !step4.model?.CrothallFinancialFollowUp) }} >

                                                <Checkbox
                                                    checked={step4.model?.CrothallFinancialFollowUp || false}
                                                    style={{ color: 'white' }}
                                                    onChange={(e) => { step4.setModel("CrothallFinancialFollowUp", e.target.checked); }}
                                                    value="checkedA"
                                                />
                                                Follow Up
                                            </Button>
                                        </Grid>
                                        <Grid item sm={8}>
                                            <span variant="title" className={classes.textBlod}>
                                                Crothall Financials: Review the following and verify accuracy within Teamfin
                                            </span>
                                        </Grid>
                                        {/* ---Grid--- */}
                                        <Grid item sm={4}></Grid>
                                        <Grid item sm={8}>
                                            <FormControl>
                                                <FormControlLabel
                                                    label="MOP-Current Period"
                                                    control={
                                                        <Checkbox
                                                            checked={step4.model?.MOPCurrentPeriod || false}
                                                            onChange={(e) => { step4.setModel("MOPCurrentPeriod", e.target.checked); }}
                                                            value="checkedA"
                                                        />
                                                    }
                                                    style={{ color: currentTheme.text }}
                                                />
                                                <FormControlLabel
                                                    label="YE Forecast"
                                                    control={
                                                        <Checkbox
                                                            checked={step4.model?.YEForecast || false}
                                                            onChange={(e) => { step4.setModel("YEForecast", e.target.checked); }}
                                                            value="checkedA"
                                                        />
                                                    }
                                                    style={{ color: currentTheme.text }}
                                                />
                                            </FormControl>
                                        </Grid>
                                        {/* ---Grid--- */}
                                        <Grid item sm={2}></Grid>
                                        <Grid item sm={2}>
                                            <Button variant="contained" className={`${classes.flButton} ${classes.green}`} onClick={() => { step4.setModel("HospitalFinancialFollowUp", !step4.model?.HospitalFinancialFollowUp) }}>

                                                <Checkbox
                                                    checked={step4.model?.HospitalFinancialFollowUp || false}
                                                    style={{ color: 'white' }}
                                                    onChange={(e) => { step4.setModel("HospitalFinancialFollowUp", e.target.checked); }}
                                                    value="checkedA"
                                                />
                                                Follow Up
                                            </Button>
                                        </Grid>
                                        <Grid item sm={8}>
                                            <span variant="title" className={classes.textBlod}>
                                                Hospital Financials: Review the following and identify if favorable to budget
                                            </span>
                                        </Grid>
                                        {/* ---Grid--- */}
                                        <Grid item sm={4}></Grid>
                                        <Grid item sm={8}>
                                            <FormControlLabel
                                                label="Current Month"
                                                control={
                                                    <Checkbox
                                                        checked={step4.model?.CurrentMonth || false}
                                                        onChange={(e) => { step4.setModel("CurrentMonth", e.target.checked); }}
                                                        value="checkedA"
                                                    />
                                                }
                                                style={{ color: currentTheme.text, width: '200px' }}
                                            />
                                            <TextField size="small"
                                                variant="outlined"
                                                type="number"
                                                value={step4.model?.CurrentMonthNumber || 0}
                                                onChange={(e) => { step4.setModel("CurrentMonthNumber", Number(e.target.value)); }}
                                                InputProps={{
                                                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                                }}
                                            />
                                            <br />
                                            <FormControlLabel
                                                label="YTD"
                                                control={
                                                    <Checkbox
                                                        checked={step4.model?.YTD || false}
                                                        onChange={(e) => { step4.setModel("YTD", e.target.checked); }}
                                                        value="checkedA"
                                                    />
                                                }
                                                style={{ color: currentTheme.text, width: '200px' }}
                                            />
                                            <TextField size="small"
                                                variant="outlined"
                                                type="number"
                                                value={step4.model?.YTDNumber || 0}
                                                onChange={(e) => { step4.setModel("YTDNumber", Number(e.target.value)); }}
                                                InputProps={{
                                                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                                }}
                                            />
                                        </Grid>
                                        {/* ---Grid--- */}
                                        <Grid item sm={3}></Grid>
                                        <Grid item sm={8}>
                                            <TextField size="small" fullWidth
                                                multiline
                                                rows="4"
                                                label="Explain Unfavorable Variances and Needed Follow Up"
                                                variant="outlined"
                                                value={step4.model?.HospitalFinancialComments || ""}
                                                className={classes.mt10}
                                                onChange={(e) => { step4.setModel("HospitalFinancialComments", e.target.value); }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item sm={1}></Grid>
                                        {/* ---Grid--- */}
                                        <Grid item sm={2}></Grid>
                                        <Grid item sm={2}>
                                            <Button variant="contained" className={`${classes.flButton} ${classes.green}`} onClick={() => { step4.setModel("ContractualAccountabilitieFollowUp", !step4.model?.ContractualAccountabilitieFollowUp) }}>

                                                <Checkbox
                                                    checked={step4.model?.ContractualAccountabilitieFollowUp || false}
                                                    style={{ color: 'white' }}
                                                    onChange={(e) => { step4.setModel("ContractualAccountabilitieFollowUp", e.target.checked); }}
                                                    value="checkedA"
                                                />
                                                Follow Up
                                            </Button>
                                        </Grid>
                                        <Grid item sm={8}>
                                            <span variant="title" className={classes.textBlod}>
                                                Contractual Accountabilities: Check all that apply
                                            </span>
                                        </Grid>
                                        {/* ---Grid--- */}
                                        <Grid item sm={4}></Grid>
                                        <Grid item container sm={8}>
                                            <Grid item>
                                                {
                                                    contractualAccountabilitieTemplate.filter((x, rowIndex) => rowIndex % 2 === 0).map((item, index) => {
                                                        return (
                                                            <div key={item.Id + '-' + index}>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            onChange={(e) => { item.Checked = e.target.checked; step4.forceUpdate(); }}
                                                                            checked={item.Checked}
                                                                        />
                                                                    }
                                                                    label={item.Option}
                                                                    style={{ color: currentTheme.text }}
                                                                />
                                                                <br />
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </Grid>
                                            <Grid item>
                                                {
                                                    contractualAccountabilitieTemplate.filter((x, rowIndex) => rowIndex % 2 !== 0).map((item) => {
                                                        return (
                                                            <div key={item.Id}>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            onChange={(e) => { item.Checked = e.target.checked; step4.forceUpdate(); }}
                                                                            checked={item.Checked}
                                                                        />
                                                                    }
                                                                    label={item.Option}
                                                                    style={{ color: currentTheme.text }}
                                                                />
                                                                <br />
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </Grid>
                                        </Grid>
                                        {/* ---Grid--- */}
                                        <Grid item sm={3}></Grid>
                                        <Grid item sm={8}>
                                            <TextField size="small" fullWidth
                                                multiline
                                                rows="4"
                                                label="Explain any checked items not current and compliant"
                                                variant="outlined"
                                                value={step4.model?.ContractualAccountabilitieComments || ""}
                                                className={classes.mt10}
                                                onChange={(e) => { step4.setModel("ContractualAccountabilitieComments", e.target.value); }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item sm={1}></Grid>
                                        {/* ---Grid--- */}
                                        <Grid item sm={12}>
                                            <TextField size="small" fullWidth
                                                multiline
                                                rows="4"
                                                label="Section Comments"
                                                variant="outlined"
                                                value={step4.model?.SectionComments || ""}
                                                className={classes.mt10}
                                                onChange={(e) => { step4.setModel("SectionComments", e.target.value); }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </Grid>
                                        {/* ---Grid--- */}
                                        <Grid item sm={12}>
                                            <FormControlLabel
                                                label="Section Complete?"
                                                control={
                                                    <Checkbox
                                                        checked={step4.model?.SectionComplete || false}
                                                        onChange={(e) => { step4.setModel("SectionComplete", e.target.checked); }}
                                                        value="checkedA"
                                                    />
                                                }
                                                style={{ color: currentTheme.text }}
                                                labelPlacement="start"
                                            />
                                        </Grid>
                                    </Grid>
                                </>
                            }
                            {
                                activeStep === 4 &&
                                <>
                                    <Grid container
                                        direction="row"
                                        justify="center"
                                        alignItems="center"
                                        spacing={1}
                                    >
                                        <Grid item sm={2}></Grid>
                                        <Grid item sm={2}>
                                            <Button variant="contained" className={`${classes.flButton} ${classes.green}`} onClick={() => { step5.setModel("ClicentFeedbackFollowUp", !step5.model?.ClicentFeedbackFollowUp) }}>

                                                <Checkbox
                                                    checked={step5.model?.ClicentFeedbackFollowUp || false}
                                                    style={{ color: 'white' }}
                                                    onChange={(e) => { step5.setModel("ClicentFeedbackFollowUp", e.target.checked); }}
                                                    value="checkedA"
                                                />
                                                Follow Up
                                            </Button>
                                        </Grid>
                                        <Grid item sm={8}>
                                            <span variant="title" className={classes.textBlod}>
                                                Client Feedback
                                            </span>
                                        </Grid>
                                        {/* ---Grid--- */}
                                        <Grid item sm={12}>
                                            <TextField size="small" fullWidth
                                                multiline
                                                rows="4"
                                                label="Section Comments"
                                                variant="outlined"
                                                value={step5.model?.SectionComments || ""}
                                                className={classes.mt10}
                                                onChange={(e) => { step5.setModel("SectionComments", e.target.value); }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </Grid>
                                        {/* ---Grid--- */}
                                        <Grid item sm={12}>
                                            <FormControlLabel
                                                label="Section Complete?"
                                                control={
                                                    <Checkbox
                                                        checked={step5.model?.SectionComplete || false}
                                                        onChange={(e) => { step5.setModel("SectionComplete", e.target.checked); }}
                                                        value="checkedA"
                                                    />
                                                }
                                                style={{ color: currentTheme.text }}
                                                labelPlacement="start"
                                            />
                                        </Grid>
                                    </Grid>
                                </>
                            }
                            <Grid container
                                direction="row"
                                justify="flex-end"
                                alignItems="center"
                                spacing={1}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    className={classes.button}
                                    style={{ background: currentTheme.secondary, width: "100px", marginRight: "10px" }}
                                    startIcon={<SaveIcon />}
                                    disabled={rdoClass.btnDisabled() || !canSave}
                                    onClick={() => { saveRdoAccountVisitation() }}
                                >
                                    Save
                                </Button>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    size="small"
                                    className={classes.button}
                                    style={{ width: "100px", marginRight: "10px" }}
                                    startIcon={<CancelIcon />}
                                    onClick={cancel}
                                    autoFocus
                                >
                                    Cancel
                                </Button>
                            </Grid>

                        </div>

                    </ValidatorForm>
                </div>
                {(showInactiveMessage) && (
                    <InactiveTimeout disContinue={cancel} />
                )}
            </>
        }


        {
            isRdoDirectorActionAdd && <RdoDirectorActionAdd
                parentCallback={cancel}
                rdoAccountVisitationSelected={rdoAccountVisitationSelected}
                theme={currentTheme}
            />
        }
    </>
    );
});
export default RdoAccountVisitationAdd;
